<div *ngIf="notes" id="notes" [innerHtml]="notes"></div>
<div id="swagger-container"></div>